import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Grid } from '@mui/material';
import { loadContactPersonsSummary } from '../actionCreators';
import { getContactPersonsSummary, getContactPersonsSummaryIsLoaded } from '../selectors';
import { useTranslation } from 'react-i18next';

const OfferPartnerContactPersonsSummary = ({ documentId, siteId, partnerId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const contactPersonsSummary = useSelector(state => getContactPersonsSummary(state, partnerId), shallowEqual);
  const isSummaryLoaded = useSelector(state => getContactPersonsSummaryIsLoaded(state, partnerId), shallowEqual);

  useEffect(() => {
    if (!isSummaryLoaded && partnerId) {
      dispatch(loadContactPersonsSummary(documentId, siteId, partnerId));
    }
  }, [isSummaryLoaded, dispatch, documentId, siteId, partnerId]);

  if (!isSummaryLoaded || !contactPersonsSummary || contactPersonsSummary.length === 0) {
    return null;
  }

  const mainContactPerson = contactPersonsSummary.find(item => item.isDefaultContact === true);
  const existsDefaultContactPerson = !!mainContactPerson;

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={4} md={6}>
          <strong>{existsDefaultContactPerson ? t('OfferEdit.Client.ContactPersons.PersonName') + ': ' : ' '}</strong>
          <span>{existsDefaultContactPerson ? `${mainContactPerson.personName || ''}` : ''}</span>
        </Grid>
        <Grid item xs={4} md={6}>
          <strong>
            {existsDefaultContactPerson && mainContactPerson.positionName ? t('OfferEdit.Client.ContactPersons.Position') + ': ' : ' '}
          </strong>
          <span>{existsDefaultContactPerson && mainContactPerson.positionName ? `${mainContactPerson.positionName || ''}` : ''}</span>
        </Grid>
      </Grid>
    </div>
  );
};

OfferPartnerContactPersonsSummary.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerId: PropTypes.number.isRequired
};

export default OfferPartnerContactPersonsSummary;
